module.exports = __webpack_public_path__ + "static/media/microsoftoffice.733d1a43.svg";